<template>
    <div class="right-main">
        <div class="right_cont">
            <component :is="currentView"></component>
        </div>
    </div>
</template>

<script>
// bottom
import InitOne from "./component/RightOne.vue";
import InitTow from "./component/RightTow.vue";
import InitThree from "./component/RightThree.vue";
import InitFour from "./component/RightFour.vue";

export default {
    name: "RightMain",
    components: {
        InitOne,
        InitTow,
        InitThree,
        InitFour,
    },
    data() {
        return {
            tabMenu: [
                /*{
                  title: "园区概览",
                  component: "InitOne",
                },
                {
                  title: "日常管理",
                  component: "InitTow",
                },
                {
                  title: "能源监管",
                  component: "InitThree",
                },
                {
                  title: "安防管理",
                  component: "InitFour",
                },*/
            ],
            currentView: "InitOne",
            currentIndex: 0,
        };
    },
    mounted() {
        this.currentView = "InitOne";
    },
    methods: {
        onItemClick(component, index) {
            this.currentView = component;
            this.currentIndex = index;
        },
    },
};
</script>

<style lang="less">
  .right-main {
    height: 100%;
    color: #fff;
    display: block;
    overflow: hidden;
    position: absolute;
    z-index: 999;

    .bot_notice {
      position: fixed;
      left: 20px;
      top: 51px;
      font-size: 12px;
    }

    .bottom_menu {
      overflow: hidden;
      clear: both;
      position: fixed;
      left: 0;
      right: 0;
      z-index: 100;
      display: flex;
      top: 45px;
      height: 34px;
      align-items: center;
      justify-content: center;

      li:nth-child(2) {
        margin-right: 270px;
      }

      li:nth-child(3) {
        margin-left: 270px;
      }

      li {
        width: 138px;
        height: 34px;
        display: block;
        text-align: center;
        font-size: 20px;
        font-style: normal;
        font-family: sans-serif;
        color: #fff;
        margin: 0 2px;
        cursor: pointer;
      }

      li.active {
        background: url(./img/bg_botmenu.png) no-repeat;
        color: rgb(238, 165, 1);
      }
    }

    .right_cont {
      width: 450px;
      height: 897px;
      // background: url(./img/bg_right.png) no-repeat;
      //background: linear-gradient(to left, rgb(6, 22, 60, 0.1), rgba(6, 22, 60, 0.1));
      background: linear-gradient(to left, rgba(0,0,0, .1), rgba(0,0,0, .1));
      position: fixed;
      right: 0px;
      top: 75px;
    }
  }
</style>
